import React, { type PropsWithChildren } from 'react';
import facade from 'context/ApplicationContext/facade';
import { ApplicationContext } from 'context/index';

const ApplicationContextComponent: React.FC<PropsWithChildren> = ({ children }) => {
   return <ApplicationContext.Provider value={facade.context$}>{children}</ApplicationContext.Provider>;
};

export default ApplicationContextComponent;
